import "./StepPreview.scss";
import React from "react";

import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Container, Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { skipToken } from "@reduxjs/toolkit/query/react";

import { SectionHeader } from "../../atoms/SectionHeader";
import { CircularLoader } from "../../atoms/Loaders";
import Stepper from "../../atoms/Stepper";
import slugConverter from "../../../utils/SlugConverter";
import { BackButtonLink } from "../../atoms/Button";
import { IsObjectEmptyOrNull } from "../../../utils/IsEmpty";
import { useGetProgrammeStepQuery } from "../../../redux/programmeStepApi";
import { Programmes } from "../../../data/Programme";
import CustomTabsPreview from "../../organisms/CustomTabsPreview/CustomTabsPreview";

const StepPreview: React.FC = () => {
  const { programmeSlug, stepNumber } = useParams();

  const currentProgramme = Programmes.find((x) => x.slug === programmeSlug);

  const {
    data: stepOverview,
    isSuccess: stepOverviewSuccess,
    isUninitialized: stepOverviewUnini,
    isError: stepOverviewIsError,
    error: stepOverviewError,
  } = useGetProgrammeStepQuery(
    !IsObjectEmptyOrNull(currentProgramme)
      ? { programmeId: currentProgramme.programmeId, stepNumber: stepNumber }
      : skipToken
  );

  return (
    <div className="main-page step-page">
      {stepOverviewSuccess &&
      !stepOverviewUnini &&
      !IsObjectEmptyOrNull(stepOverview) ? (
        <>
          <Helmet>
            <title>
              {`${stepOverview.title} | ${slugConverter.toTitleCase(
                stepOverview.programmeSlug
              )} |  My Path | Gloji`}
            </title>
          </Helmet>
          <Container className="main-content__container">
            <section>
              <div className="header">
                <div className="back-button">
                  <BackButtonLink
                    linkPath={`/my-path/${programmeSlug}/preview`}
                    btnText="My path"
                    ariaLabel="Back to My path"
                  />
                </div>
                <div className="header__inner">
                  <div className="header__title">{currentProgramme?.name}</div>
                </div>
              </div>
              {stepOverview.stepNumber !== 0 && (
                <SectionHeader>
                  <Stepper
                    totalSteps={currentProgramme.totalSteps - 1}
                    completedSteps={[]}
                    currentStep={parseInt(stepNumber)}
                  />
                </SectionHeader>
              )}
              <div className="parts-and-sections ">
                {stepOverviewIsError ? (
                  <>
                    <Grid container>
                      <Grid item xs={12}>
                        <div style={{ height: "60vh", paddingTop: "4rem" }}>
                          <Alert severity="error">
                            <AlertTitle>{stepOverviewError} </AlertTitle>
                            Failed to load data
                          </Alert>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  !IsObjectEmptyOrNull(stepOverview) && (
                    <CustomTabsPreview stepData={stepOverview} />
                  )
                )}
              </div>
            </section>
          </Container>
        </>
      ) : (
        <CircularLoader color="primary" size={40} />
      )}
    </div>
  );
};

export default StepPreview;
